import INVENTORY_API_BASE_URL from "../../config/api";























































import "./Pogiven.css";
import { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

import image from "../../uploads/signature.png";
import image2 from "../../uploads/pinnacle_logo.png";

function POgiven() {
  const [data, setData] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      const [orders, suppliers] = await Promise.all([
        Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`),
        Axios.get(`${INVENTORY_API_BASE_URL}/getbooksupplier`),
      ]);
      setData(orders.data);
      setSuppliers(suppliers.data);
    };
    fetchData();
  }, []);

  const pageSize = 20;
  const approvedOrders = data.filter((order) => order.ApprovalDate);
  const totalPages = Math.max(1, Math.ceil(approvedOrders.length / pageSize));
  const pageStartIndex = (currentPage - 1) * pageSize;
  const pageOrders = approvedOrders.slice(pageStartIndex, pageStartIndex + pageSize);
  const firstVisibleOrder = approvedOrders.length === 0 ? 0 : pageStartIndex + 1;
  const lastVisibleOrder = Math.min(pageStartIndex + pageSize, approvedOrders.length);

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

  const openPDF = (order) => {
    let subtotal = 0;
    let totalQty = 0;

    order.updatedQuantity.forEach((i) => {
      subtotal += i.purchasePrice * i.approvedquantity;
      totalQty += i.approvedquantity;
    });

    const gst = order.gst ?? 12;
    const base = subtotal / (1 + gst / 100);
    const gstAmt = subtotal - base;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    const win = iframe.contentWindow;

    win.document.write(`<!DOCTYPE html>
<html>
<head>
<title></title>
<style>
.no-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

.summary,
.footer {
  page-break-inside: avoid;
  break-inside: avoid;
}

body { font-family: Arial; padding: 15px; }
.page { width: 100%; }
.header { text-align: center; margin-bottom: 10px; }
.logo { position: absolute; left: 15px; top: 10px; }
.flex { display: flex; justify-content: space-between; margin-top: 20px; }
.box { border: 1px solid #000; padding: 8px; width: 48%; }
.boxsig { border: 1px solid #000; width: 100%; }
.image { border: 1px solid #000; text-align: right; padding: 8px; }
.qty {  solid #000; text-align: left; }
table { width: 100%; border-collapse: collapse; margin-top: 10px; }
.footer-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}

.footer-left {
  padding-left: 20px;
  
}

  
.footer-center {
  text-align: right;
 padding: 10px;
}

th, td { border: 1px solid #000; padding: 6px; font-size: 12px; }
th { background: #f0f0f0; }
img.book { width: 60px; height: 60px; object-fit: contain; }
.summary { margin-top: 20px; display: flex; justify-content: flex-end; }
.summary div { text-align: right; }
.footer { margin-top: 30px; text-align: right; }
@media print {
  body { margin: 0; }
}
</style>
</head>

<body>
<div class="page">

<img src="${image2}" class="logo" width="150" />

<div class="header">
  <h2>Purchase Order</h2>
  
  <b>PINNACLE CIVIL SERVICES</b><br/>
  1st Floor, 1032A, MM Tower, New Railway Road,<br/>
  Dayanand Colony, Gurugram, Haryana 122001 Code : 6
</div>

<div style="text-align:right">
  <b>Order No :</b> ${order.orderid}<br/>
  <b>Date :</b> ${formatDate(order.ApprovalDate)}
</div>

<div class="flex">
  <div class="box">
    <b>Vendor</b><br/>
    ${suppliers
      .map((s) => `${s.Booksupplier}<br/>${s.Address}`)
      .join("<br/><br/>")}
  </div>

  <div class="box">
    <b>Ship To</b><br/>
    Pinnacle Civil Services<br/>
    Hare Ram Plaza Basement, Old Railway Road,Sector 4<br/>
    Near by Chintapurni Mandir Below Redtap Showroom<br/>
    Gurugram, Haryana, 122001
  </div>
</div>

<table>
<thead>
<tr>
<th>SN</th>
<th>Description</th>
<th>Image</th>
<th>Qty</th>
<th>Unit Price</th>
<th>Total</th>
</tr>
</thead>
<tbody>
${order.updatedQuantity
  .map(
    (i, idx) => `
<tr>
<td>${idx + 1}</td>
<td>
  ${i.title}<br/>
  Medium: ${i.Medium}<br/>
  Edition: ${i.edition}
</td>
<td>
  <img class="book"
    src="https://d10idqgatxnd06.cloudfront.net/${i.img}" />
</td>
<td>${i.approvedquantity}</td>
<td>${i.purchasePrice.toFixed(2)}</td>
<td>${(i.purchasePrice * i.approvedquantity).toFixed(2)}</td>
</tr>
`
  )
  .join("")}
</tbody>
</table>

<div class="no-break">
  <div class="summary">
    <div>
      Base Amount: ${base.toFixed(2)}<br/>
      GST @${gst}%: ${gstAmt.toFixed(2)}<br/>
      <b>Total: ${subtotal.toFixed(2)}</b><br/>
     
    </div>
  </div>
<br/>
  <div class="boxsig footer-flex">
  <div class="footer-left">
    <b>Total Qty : ${totalQty}</b>
  </div>

  <div class="footer-center">
    For Pinnacle Civil Services<br/>
    <img src="${image}" width="120" /><br/>
    Authorized Signature
  </div>
</div>

</div>


<script>
window.onload = () => window.print();
</script>

</body>
</html>
`);
    win.document.close();
    win.document.title = "\u200B";
  };

  return (
    <div className="pogiven-wrapper">
      <main className="pogiven-workspace">
        <header className="pogiven-header">
          <div>
            <span className="pogiven-eyebrow">Procurement / Order history</span>
            <h1>Purchase orders given</h1>
            <p>Review approved orders and open a print-ready purchase order document.</p>
          </div>
          <div className="pogiven-header-badge">
            <span aria-hidden="true" />
            Approved orders
          </div>
        </header>

        <section className="pogiven-overview" aria-label="Purchase order summary">
          <article className="pogiven-stat-card">
            <span className="pogiven-stat-mark" aria-hidden="true">01</span>
            <div>
              <span className="pogiven-stat-label">All purchase orders</span>
              <strong>{data.length}</strong>
              <small>Order records in the system</small>
            </div>
          </article>
          <article className="pogiven-stat-card">
            <span className="pogiven-stat-mark pogiven-stat-mark--approved" aria-hidden="true">02</span>
            <div>
              <span className="pogiven-stat-label">Approved orders</span>
              <strong>{approvedOrders.length}</strong>
              <small>Ready to view and print</small>
            </div>
          </article>
          <article className="pogiven-stat-card">
            <span className="pogiven-stat-mark pogiven-stat-mark--supplier" aria-hidden="true">03</span>
            <div>
              <span className="pogiven-stat-label">Supplier records</span>
              <strong>{suppliers.length}</strong>
              <small>Available in the supplier directory</small>
            </div>
          </article>
        </section>

        <section className="pogiven-orders-panel" aria-label="Approved purchase orders">
          <div className="pogiven-panel-header">
            <div>
              <span className="pogiven-section-eyebrow">Order register</span>
              <h2>Approved purchase orders</h2>
              <p>Use View PDF to open or print the complete order document.</p>
            </div>
            <span className="pogiven-order-count">
              {approvedOrders.length}{" "}
              {approvedOrders.length === 1 ? "ORDER" : "ORDERS"}
            </span>
          </div>

          <div className="pogiven-table-wrap">
            <Table className="POgiventable">
              <thead>
                <tr>
                  <th scope="col">Order number</th>
                  <th scope="col">Created</th>
                  <th scope="col">Approved</th>
                  <th scope="col">Total quantity</th>
                  <th scope="col">Document</th>
                </tr>
              </thead>
              <tbody>
                {approvedOrders.length > 0 ? (
                  pageOrders.map((row) => (
                      <tr key={row.orderid}>
                        <td data-label="Order number">
                          <span className="pogiven-order-id">{row.orderid}</span>
                        </td>
                        <td data-label="Created">
                          <time dateTime={row.date}>{formatDate(row.date)}</time>
                        </td>
                        <td data-label="Approved">
                          <time dateTime={row.ApprovalDate}>{formatDate(row.ApprovalDate)}</time>
                        </td>
                        <td data-label="Total quantity">
                          <span className="pogiven-quantity">
                            {row.updatedQuantity.reduce(
                              (a, b) => a + b.approvedquantity,
                              0
                            )}
                          </span>
                        </td>
                        <td data-label="Document">
                          <Button
                            className="pogiven-pdf-button"
                            onClick={() => openPDF(row)}
                          >
                            View PDF
                            <span aria-hidden="true">↗</span>
                          </Button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td className="pogiven-empty-cell" colSpan={5}>
                      <div className="pogiven-empty-state">
                        <span className="pogiven-empty-mark" aria-hidden="true">PO</span>
                        <strong>No approved purchase orders yet</strong>
                        <span>Approved orders will appear here when they are ready to view.</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="pogiven-panel-footer">
            <span className="pogiven-range">
              Showing {firstVisibleOrder}–{lastVisibleOrder} of {approvedOrders.length} approved orders
            </span>
            {totalPages > 1 && (
              <nav className="pogiven-pagination" aria-label="Purchase order pages">
                <button
                  className="pogiven-page-button"
                  type="button"
                  onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="pogiven-page-status" aria-live="polite">
                  Page <strong>{currentPage}</strong> of {totalPages}
                </span>
                <button
                  className="pogiven-page-button"
                  type="button"
                  onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </nav>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}

export default POgiven;
